export const CHANGE_CURRENT_PAGE = 'payPalSettings/CHANGE_CURRENT_PAGE'
export const CHANGE_PAGE_SIZE = 'payPalSettings/CHANGE_PAGE_SIZE'
export const CREATE_PAYPAL_SETTING = 'payPalSettings/CREATE_PAYPAL_SETTING'
export const FETCH_PAYPAL_SETTINGS_LIST = 'payPalSettings/FETCH_PAYPAL_SETTINGS_LIST'
export const FETCH_PAYPAL_SETTINGS_FOR_OPTIONS = 'payPalSettings/FETCH_PAYPAL_SETTINGS_FOR_OPTIONS'
export const REMOVE_PAYPAL_SETTING = 'payPalSettings/REMOVE_PAYPAL_SETTING'
export const UPDATE_PAYPAL_SETTING = 'payPalSettings/UPDATE_PAYPAL_SETTING'
